import { Injectable } from '@angular/core';
import Moment from 'moment';

/** Resultado de convertir un timestamp Unix (segundos) a hora del día. */
export interface UnixTimeOfDayResult {
  /** Minutos desde medianoche (0–1439) en la zona horaria indicada. */
  minutes: number;
  /** Hora legible en formato HH:mm. */
  timeStr: string;
}


export type TimeFilter = 'today' | '7days' | '30days' | 'month' | 'currentYear' | 'previousYear' | 'custom';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }


  secondsToDhms(date1: string | Date, date2: string | Date): string {
    let actualDate = new Date(date1).getTime();
    let initDate = new Date(date2).getTime();
    let seconds = (actualDate - initDate) / 1000;
    let d = Math.floor(seconds / (3600 * 24));
    let h = Math.floor((seconds % (3600 * 24)) / 3600);
    let m = Math.floor((seconds % 3600) / 60);
    let s = Math.floor(seconds % 60);

    let dDisplay = d > 0 ? d + (d == 1 ? ' d ' : ' d ') : '';
    let hDisplay = h > 0 ? h + (h == 1 ? ' h ' : ' h ') : '';
    let mDisplay = m > 0 ? m + (m == 1 ? ' m ' : ' m ') : '';
    // let sDisplay = s > 0 ? s + (s == 1 ? ' s' : ' s') : '';
    console.log(dDisplay + hDisplay + mDisplay );
    return dDisplay + hDisplay + mDisplay ;
  }

  subtractDates(date1: string | Date, date2: string | Date): string {
    // if (!date2.toString().includes('Z') && !date2.toString().includes('GMT')) {
    //   date2 = new Date(date2 + " UTC");
    // }
    var difference_ms = new Date(date1).getTime() - new Date(date2).getTime();
    //take out milliseconds
    difference_ms = difference_ms / 1000;
    var seconds = Math.floor(difference_ms % 60);
    difference_ms = difference_ms / 60;
    var minutes = Math.floor(difference_ms % 60);
    difference_ms = difference_ms / 60;
    var hours = Math.floor(difference_ms % 24);
    if (hours != 0)
      return hours + 'h ' + minutes.toString() + 'm ' + seconds.toString() + 's';
    else return minutes.toString() + 'm ' + seconds.toString() + 's';
  }

  subtractDates2(date1: string | Date, date2: string | Date): string {
    if (!date2.toString().includes('Z') && !date2.toString().includes('GMT')) {
      date2 = new Date(date2 + " UTC");
    }
    var difference_ms = new Date(date1).getTime() - new Date(date2).getTime();
    //take out milliseconds
    difference_ms = difference_ms / 1000;
    var seconds = Math.floor(difference_ms % 60);
    difference_ms = difference_ms / 60;
    var minutes = Math.floor(difference_ms % 60);
    difference_ms = difference_ms / 60;
    var hours = Math.floor(difference_ms % 24);
    if (hours != 0)
      return hours + 'h ' + minutes.toString() + 'm ' + seconds.toString() + 's';
    else return minutes.toString() + 'm ' + seconds.toString() + 's';
  }

  getDateFromMinutes(minutes: number): string {
    const total = Math.trunc(Number(minutes) || 0);
    const sign = total < 0 ? '-' : '';
    const absTotal = Math.abs(total);
    const hour = Math.floor(absTotal / 60);
    const min = absTotal % 60;
    return `${sign}${hour.toString().padStart(2, '0')}:${min.toString().padStart(2, '0')}`;
  }

  /**
   * Convierte un timestamp Unix (segundos, estilo Linux) a hora del día.
   * Devuelve minutos y texto legible en una sola pasada.
   *
   * @param unixSec Segundos desde epoch (p. ej. orto/ocaso de astcal).
   * @param timeZone IANA opcional (p. ej. 'Europe/Madrid'). Sin valor, usa la zona local del navegador.
   */
  parseUnixTimeOfDay(unixSec: unknown, timeZone?: string): UnixTimeOfDayResult | null {
    const ts = Number(unixSec);
    if (!Number.isFinite(ts) || ts <= 0) {
      return null;
    }

    const date = new Date(ts * 1000);
    const parts = this.getTimePartsFromDate(date, timeZone);
    if (!parts) {
      return null;
    }

    const minutes = parts.hour * 60 + parts.minute;
    return {
      minutes,
      timeStr: this.getDateFromMinutes(minutes),
    };
  }

  /** Atajo para templates: solo la hora legible o un fallback. */
  formatUnixTimeOfDay(unixSec: unknown, timeZone?: string, fallback = '--:--'): string {
    return this.parseUnixTimeOfDay(unixSec, timeZone)?.timeStr ?? fallback;
  }

  private getTimePartsFromDate(
    date: Date,
    timeZone?: string,
  ): { hour: number; minute: number } | null {
    if (timeZone) {
      try {
        const dtf = new Intl.DateTimeFormat('en-US', {
          timeZone,
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
          hour12: false,
        });
        const values: Record<string, string> = {};
        for (const part of dtf.formatToParts(date)) {
          if (part.type !== 'literal') {
            values[part.type] = part.value;
          }
        }
        const hour = Number(values.hour);
        const minute = Number(values.minute);
        if (Number.isFinite(hour) && Number.isFinite(minute)) {
          return { hour, minute };
        }
      } catch {
        // fallback a zona local del navegador
      }
    }

    const hour = date.getHours();
    const minute = date.getMinutes();
    if (!Number.isFinite(hour) || !Number.isFinite(minute)) {
      return null;
    }

    return { hour, minute };
  }

  update(objToUpdate: any, updateObj: any): any {
    if(objToUpdate!=null&&objToUpdate!=undefined&&updateObj!=null&&updateObj!=undefined){
      objToUpdate=updateObj;
    } else objToUpdate=[-1,-1,-1];
  }

  getFormatedLocalDate = (date = new Date(), format = 'YYYY-MM-DD') => {
      return Moment(date).local().format(format)
  }

  getFormatedUTCDate = (date = new Date(), format = 'YYYY-MM-DDTHH') => {
    return Moment(date).utc().format(format)
  }

  resolveDateRange(
    filter: TimeFilter,
    customStartDate?: string,
    customEndDate?: string
  ): { from: Date; to: Date } {
    const now = new Date();
    let from = now;
    let to = now;

    switch (filter) {
      case 'today':
        from = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        break;
      case '7days':
        from = new Date(now);
        from.setDate(from.getDate() - 7);
        break;
      case '30days':
        from = new Date(now);
        from.setDate(from.getDate() - 30);
        break;
      case 'currentYear':
        from = new Date(now.getFullYear(), 0, 1);
        break;
      case 'previousYear':
        from = new Date(now.getFullYear() - 1, 0, 1);
        to = new Date(now.getFullYear() - 1, 11, 31);
        break;
      case 'month':
      case 'custom':
        if (customStartDate && customEndDate) {
          from = new Date(customStartDate);
          to = new Date(customEndDate);
          to.setHours(23, 59, 59, 999);
        } else if (filter === 'month') {
          from = new Date(now.getFullYear(), now.getMonth(), 1);
        }
        break;
    }
    return { from, to };
  }


    setDaysFromBitmask(mask: number): any {
    if (mask === 0) {
      return {
        sunday: true,
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: true
      };
    }

    const safeMask = mask ?? 0;
    return {
      saturday:   !!(safeMask & (1 << 6)),
      friday:     !!(safeMask & (1 << 5)),
      thursday:   !!(safeMask & (1 << 4)),
      wednesday:  !!(safeMask & (1 << 3)),
      tuesday:    !!(safeMask & (1 << 2)),
      monday:     !!(safeMask & (1 << 1)),
      sunday:     !!(safeMask & (1 << 0))
    };
  }
}


